import { Injectable } from "@angular/core";

export interface NamedPromptCategoryValue {
  key: string;
  label: string;
}

export interface NamedPromptCategories {
  RTS: Readonly<NamedPromptCategoryValue>;
  ACTUALITE: Readonly<NamedPromptCategoryValue>;
  MARKETING: Readonly<NamedPromptCategoryValue>;
  MES_PROMPTS: Readonly<NamedPromptCategoryValue>;
  PRODUCTION: Readonly<NamedPromptCategoryValue>;
  SPORT: Readonly<NamedPromptCategoryValue>;
  TRANSCRIPTIONS: Readonly<NamedPromptCategoryValue>;
  SUMMARY: Readonly<NamedPromptCategoryValue>;
  FORMATION: Readonly<NamedPromptCategoryValue>;
  GESTION_PROJET: Readonly<NamedPromptCategoryValue>;
  DISTRIBUTION_B2B: Readonly<NamedPromptCategoryValue>;
  ACTU_RADIO: Readonly<NamedPromptCategoryValue>;
  IMI_EPFL: Readonly<NamedPromptCategoryValue>;
  D_PLUS_A: Readonly<NamedPromptCategoryValue>;
  COULEUR3: Readonly<NamedPromptCategoryValue>;
  KEYPOINTS: Readonly<NamedPromptCategoryValue>;
  INSTAGRAM: Readonly<NamedPromptCategoryValue>;
  WHATSAPP: Readonly<NamedPromptCategoryValue>;
  LARGE: Readonly<NamedPromptCategoryValue>;
  SIMPLIFIED: Readonly<NamedPromptCategoryValue>;
  ARTICLE: Readonly<NamedPromptCategoryValue>;
  ARTICLE_QUOTES: Readonly<NamedPromptCategoryValue>;
  TITLE: Readonly<NamedPromptCategoryValue>;
}

export type NamedPromptCategory = keyof NamedPromptCategories;

@Injectable({
  providedIn: "root",
})
export class NamedPromptCategoryService {
  namedPromptCategories: NamedPromptCategories = Object.freeze({
    RTS: Object.freeze({ key: "RTS", label: "RTS" }),
    ACTUALITE: Object.freeze({ key: "ACTUALITE", label: "Actualité" }),
    MARKETING: Object.freeze({ key: "MARKETING", label: "Marketing" }),
    MES_PROMPTS: Object.freeze({
      key: "MES_PROMPTS",
      label: $localize`:@@prompt_category_label_my_prompts:Mes prompts`,
    }),
    PRODUCTION: Object.freeze({ key: "PRODUCTION", label: "Production" }),
    SPORT: Object.freeze({ key: "SPORT", label: "Sport" }),
    TRANSCRIPTIONS: Object.freeze({ key: "TRANSCRIPTIONS", label: "Transcription" }),
    SUMMARY: Object.freeze({ key: "SUMMARY", label: $localize`:@@prompt_category_label_summary:Summary` }),
    FORMATION: Object.freeze({ key: "FORMATION", label: "Formation" }),
    GESTION_PROJET: Object.freeze({ key: "GESTION_PROJET", label: "Gestion de projet" }),
    DISTRIBUTION_B2B: Object.freeze({ key: "DISTRIBUTION_B2B", label: "Distribution B2B" }),
    ACTU_RADIO: Object.freeze({ key: "ACTU_RADIO", label: "Actu Radio" }),
    IMI_EPFL: Object.freeze({ key: "IMI_EPFL", label: "IMI-EPFL" }),
    COULEUR3: Object.freeze({ key: "COULEUR3", label: "Couleur3" }),
    D_PLUS_A: Object.freeze({ key: "D_PLUS_A", label: "D+A" }),
    KEYPOINTS: Object.freeze({ key: "KEYPOINTS", label: $localize`:@@prompt_category_label_bulletpoints:Points Clés` }),
    INSTAGRAM: Object.freeze({ key: "INSTAGRAM", label: $localize`:@@prompt_category_label_instagram:Instagram` }),
    WHATSAPP: Object.freeze({ key: "WHATSAPP", label: $localize`:@@prompt_category_label_whatsapp:WhatsApp` }),
    LARGE: Object.freeze({ key: "LARGE", label: $localize`:@@prompt_category_label_long:Long` }),
    SIMPLIFIED: Object.freeze({ key: "SIMPLIFIED", label: $localize`:@@prompt_category_label_simple:Simplifié` }),
    ARTICLE: Object.freeze({ key: "ARTICLE", label: $localize`:@@prompt_category_label_article:Article` }),
    ARTICLE_QUOTES: Object.freeze({
      key: "ARTICLE_QUOTES",
      label: $localize`:@@prompt_category_label_quotes:Citations`,
    }),
    TITLE: Object.freeze({ key: "TITLE", label: $localize`:@@prompt_category_label_title:Titre` }),
  });

  getPromptLabel(category: string): string {
    return category in this.namedPromptCategories
      ? this.namedPromptCategories[category as NamedPromptCategory].label
      : category;
  }
}
